var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup734(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 383.787,
    height: 332.56,
    viewBox: "0 0 383.787 332.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M-3715,406s99.841-8.275,169.9-34.22,58.765-63.562,110.335-69.559,93.545,26.384,93.545,26.384V182.292S-3484.536,51.942-3545.1,76.527s-90.033,56.705-146.9,82.49-23,143.2-23,143.2Z",
    transform: "translate(3716)",
    fill: "#f9c8c5",
    opacity: 0.53
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(9.008 -73.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M-3715,406s99.841-8.275,169.9-34.22,58.765-63.562,110.335-69.559,93.545,26.384,93.545,26.384V182.292s-85.749-7.8-146.313,16.79-39.077,55.767-95.943,81.552S-3715,302.221-3715,302.221Z",
    transform: "translate(3715)",
    fill: "#f9c8c5",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(35.739 73.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M2252.749,1736.487s.055.507.055,1.353c0,2.539-.494,8.134-4.461,12.262-5.292,5.5-5.323,12.352.267,13.522s18.92-.374,18.92-.374,3.013-5.237.956-19.225-3.252-29.329-3.252-29.329l-15.189-2.372Z",
    transform: "translate(-2061.602 -1326.722)",
    fill: "#ff7446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M2244.973,1799.666s-5.634,7.645-6.953,10.836-1.035,11.124,0,11.941c9.111,7.193,26.385.719,26.385.719a102.915,102.915,0,0,0,1.787-11.748c.6-6.474.261-12.506-1.787-12.506s-2.408,3.4-7.084,2.436S2249.769,1798.706,2244.973,1799.666Z",
    transform: "translate(-2056.802 -1383.953)",
    fill: "#001653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M2265.839,1845.31a60.6,60.6,0,0,1-12.714,3.609c-4.732.676-11.1-1.431-15.911-3.548-.249,3.392.108,7.191.807,7.744,9.111,7.193,26.385.719,26.385.719S2265.219,1850.223,2265.839,1845.31Z",
    transform: "translate(-2056.803 -1414.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M2265.994,1845.31c-13.071,3.926-15.476,4.622-28.625.061a39.908,39.908,0,0,0,6.875,2.906c5.052,1.567,8.036,1.43,11.188.722A48.5,48.5,0,0,0,2265.994,1845.31Z",
    transform: "translate(-2056.958 -1414.625)",
    fill: "#957447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M1809.453,985.728c3.739,1.406,8.7,3.494,8.7,3.494.641-1.543-11.7-4.181-13.432-7.938-.927-2.012,14.163,5.392,15.211,4.51.435-.366-17.069-6.064-16.261-7.44.678-1.156,18.4,5.092,18.5,4.227.136-1.2-15.347-4.307-13.96-6.037.71-.886,19.5,4.2,21.529,4.493,2.481,0-6.5-6.1-3.438-6.913,4.153-1.108,14.581,10.848,15.4,11.016,2.361.49,22.461,2.95,32.3-3.486,7.949-5.2,15.661-13.194,17.548-20.078,1.851-6.749,4.416-16.389,2.224-23.826a97.636,97.636,0,0,1,26.724-.59c.552,11.167-12.818,55.417-18.409,59.058-12.3,8.01-34.242,6.051-49.712,4.777-12.468-1.026-24.679-3.482-35.908-9.181-2.51-1.274-5.872-2.7-7.815-4.918A.732.732,0,0,1,1809.453,985.728Z",
    transform: "translate(-1770.265 -813.909)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M2063.686,803.557c-6.663,6.882-13.391,48.116-10.915,57.944,4.275,7.983,23.637,9.361,29.9,13.147,14.444-5.939,4.549-32.573,4.549-32.573l5.266-51.878A44.671,44.671,0,0,0,2063.686,803.557Z",
    transform: "translate(-1934.592 -717.199)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M2075.319,1737.465a15.846,15.846,0,0,1-5.031,17.118,26.633,26.633,0,0,1-6.063,3.741c-8.848,3.868-20.308,3-21.905,10.943s56.1-2.23,56.1-2.23-4-19.324-4.263-22.561.353-15.123.353-15.123l-22.284-1.6Z",
    transform: "translate(-1928.009 -1336.921)",
    fill: "#ff7446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M2094.507,1795.675s.706,3.068,2.321,8.271a22.546,22.546,0,0,1,.608,10.1s-54.046,2.56-56.233.849-1.064-7.943-.511-8.5,7.412-2.4,10.929-4.575,15.531-10.382,19.59-10.05,5.933,3.33,13.641,3.672S2092.593,1794.177,2094.507,1795.675Z",
    transform: "translate(-1926.436 -1379.233)",
    fill: "#001653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M2041.2,1843.43c2.188,1.712,56.233-.849,56.233-.849a22.627,22.627,0,0,0,.054-7.2c-28.213,5.227-56.8-.444-56.8-.444C2040.138,1835.487,2039.015,1841.718,2041.2,1843.43Z",
    transform: "translate(-1926.436 -1407.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M2099.02,1835.38a147.463,147.463,0,0,1-56.8-.444c29.418,4.442,53.139,1,51.5,1.166Z",
    transform: "translate(-1927.965 -1407.768)",
    fill: "#957447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M2140.8,1159.527c9.273,33.908-2.24,186.008-2.24,186.008l-27.761-1.9s-6.316-151.31-10.9-155.89a2.8,2.8,0,0,0-3.886-.156,6.027,6.027,0,0,0-2.3,3.223c-2.857,9.337-19.186,63.683-15.894,75.584,3.6,13.031,19.689,82.841,19.689,82.841l-23.294.931s-31.937-53.332-31.937-90.564,5.195-86.586,20.287-106.667c6.869-9.14,40.689-16.211,40.689-16.211S2137.906,1148.935,2140.8,1159.527Z",
    transform: "translate(-1928.008 -946.254)",
    fill: "#382054"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(142.497 206.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M2145.654,1443.346s-16.085-74.435-19.689-88.331c-2.618-10.089,7.171-48.795,12.727-69.234a8.927,8.927,0,0,1,14.072-4.719h0s-23.517,66.474-19.913,79.5,19.689,82.841,19.689,82.841l-23.294.931s-.058-.1-.169-.286Z",
    transform: "translate(-2125.528 -1246.66)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M2309.36,1183.225c2.976,2.327,5.128,4.72,5.762,7.037,9.273,33.908-2.24,186.008-2.24,186.008l-6.875-.47C2306.394,1370.3,2316.362,1227.133,2309.36,1183.225Z",
    transform: "translate(-2244.824 -1183.225)",
    fill: "#462c65"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M2086.4,1187.607a51.766,51.766,0,0,1,5.333-9.092,14.852,14.852,0,0,1,3.389-3.093,104.356,104.356,0,0,0,16.574,6.39c22.255,6.843,46.249,3.2,56.219-.276a9.653,9.653,0,0,1,2.048,3.568,77.7,77.7,0,0,1,1.965,11.315c-4.977,3.7-33.909,12.646-60.232,4.269C2094.988,1195.371,2088.761,1192.15,2086.4,1187.607Z",
    transform: "translate(-1957.166 -971.832)",
    fill: "#462c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M2265.33,1753.22c-7.113,2.31-24.234,1.737-28.322,0-3.77-1.6-4.025-15.623,0-16.384,5.655-1.069,21.684-.95,28.322,0C2269.385,1737.416,2269.226,1751.956,2265.33,1753.22Z",
    transform: "translate(-2054.786 -1342.423)",
    fill: "#5d70a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M2140.806,1734.741c-7.114,2.309-24.234,1.736-28.323,0-3.77-1.6-4.024-15.624,0-16.385,5.655-1.069,21.684-.95,28.323,0C2144.861,1718.937,2144.7,1733.477,2140.806,1734.741Z",
    transform: "translate(-1972.476 -1330.208)",
    fill: "#5d70a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M2129.3,784.02s23.15-1.19,32.613,10.022,8.688,129.006,4.859,132.292-36.732,13.215-62.865,5.483-27.8-18.348-27.8-18.348,6.953-79.217,6.953-100.868S2104.2,778.195,2129.3,784.02Z",
    transform: "translate(-1950.367 -712.184)",
    fill: "#febcba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M2267.806,914.174c2.046-5.688-.144-23.779-2.472-36.867-1.822.349-3.575.763-5.23,1.241-2.8-8.657-5.261-31.125-5.343-45.251-.155-26.5,13.259-34.2,13.259-34.2,2.658-.607,6.911,1.895,13.562,8.819,7.683,21,6.074,118.759,2.473,121.849-1.535,1.317-4.538,9.58-12.279,11.22C2269.764,933.082,2265.916,919.432,2267.806,914.174Z",
    transform: "translate(-2068.452 -723.023)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M2185.406,784c5.021,4.615,5.41,4.7.194,10.757s-22.485,12.937-24.948,11.775c-6.112-2.886-.424-12.52,3.645-19.449C2165.568,784.923,2180.386,779.39,2185.406,784Z",
    transform: "translate(-2004.475 -711.925)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M2171.543,662.674s-1.352,31.88,0,33.276,20.726-5.352,22.416-9.308-7.061-61.588-7.061-61.588Z",
    transform: "translate(-2013.05 -608.04)",
    fill: "#f6a268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M2170.99,700.926c3.425-.617,6.373-1.488,7.239-2.466,7.9-8.928,1.981-23.414,2.6-27.182,1.236-7.5,3.754-13.692,2.492-20.156L2171.575,679.9S2171.087,691.431,2170.99,700.926Z",
    transform: "translate(-2013.082 -625.271)",
    fill: "#e97c31",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(0 66.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M1865.593,838.977c-1.318,3.32,1.422,6.539,4.29,5.113a3.1,3.1,0,0,0,1.469-1.64c1.322-3.322-1.422-6.545-4.291-5.113A3.1,3.1,0,0,0,1865.593,838.977Z",
    transform: "translate(-1810.99 -814.162)",
    fill: "#00424c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M1860.476,796.069l.98,1.375.594-1.646c.775-2.146,7.357-21.1.089-25.411a3.817,3.817,0,0,0-5.548,1.119C1853.415,776.072,1854.4,787.547,1860.476,796.069Zm-2.437-23.215a2.009,2.009,0,0,1,2.523-.9,4.141,4.141,0,0,1,.731.349c4.415,2.621,1.629,14.7-.364,20.922C1856.074,785.345,1855.875,775.964,1858.039,772.854Z",
    transform: "translate(-1804.095 -769.657)",
    fill: "#00424c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(57.299 12.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M1874.209,818.555l1.515.328a19.442,19.442,0,0,0,4.1.437c6.744,0,12.634-3.486,14.059-7.51a4.736,4.736,0,0,0-1.658-5.582c-6.05-4.7-15.947,9.314-17.054,10.93Zm3.463-1.514c2.828-3.759,8.071-9.623,11.737-9.623a2.8,2.8,0,0,1,1.775.594,2.446,2.446,0,0,1,.975,2.983C1891.032,814.184,1884.851,817.9,1877.672,817.04Z",
    transform: "translate(-1874.209 -805.268)",
    fill: "#00424c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    d: "M26.629,0H82.5a26.631,26.631,0,0,1,26.631,26.631V55.718A26.629,26.629,0,0,1,82.5,82.347H26.63A26.63,26.63,0,0,1,0,55.717V26.629A26.629,26.629,0,0,1,26.629,0Z",
    transform: "translate(109.128 109.186) rotate(180)",
    fill: "#ffa5a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M1712.329,848.826h34.108v82.347h-34.108c-3.944,0-7.141-5.11-7.141-11.412V860.238C1705.188,853.935,1708.385,848.826,1712.329,848.826Z",
    transform: "translate(-1705.188 -821.987)",
    fill: "#dc7572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M1917.351,848.826h2.691c14.557,26.279,5.638,72.311,3.444,82.347h-2.1c1.506-6.762,11.906-56.828-3.91-82.1A1.681,1.681,0,0,1,1917.351,848.826Z",
    transform: "translate(-1845.427 -821.987)",
    fill: "#00424c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M1760.455,930.862a2.493,2.493,0,0,1,.02.311h-1.995c-5.874-46.916.607-71.734,4.984-82.347h2.467C1761.95,857.7,1754.311,882.148,1760.455,930.862Z",
    transform: "translate(-1738.862 -821.987)",
    fill: "#00424c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(179.67 215.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    d: "M6.874,0h58.9a6.874,6.874,0,0,1,6.874,6.874V41.922A6.873,6.873,0,0,1,65.771,48.8H6.873A6.873,6.873,0,0,1,0,41.922V6.874A6.874,6.874,0,0,1,6.874,0Z",
    transform: "translate(74.197 48.795) rotate(180)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 61.53,
    height: 37.556,
    transform: "translate(65.855 43.175) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 6.488,
    height: 21.473,
    rx: 3.244,
    transform: "translate(6.488 35.134) rotate(180)",
    fill: "#f29913"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M2300.788,1015.111c-4.579,13.936,11.547,44.08,5,53.726s-3.254,19.776,4.683,24.8,17.8-2.016,17.007-5.839-2.936-14.116-3.915-18.821,17.482-42.4,4.487-65.263c-7.711-13.566,3.691-36.913-2.332-52-5.391,10.047-30.91,3.769-29.446,14.794C2298.6,975.923,2303.362,1007.279,2300.788,1015.111Z",
    transform: "translate(-2095.85 -823.96)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M2132.687,635.549s-3.323,11.441-3.323,20.823.222,25.629,6.868,25.629,16.172-1.831,18.388-15.1,0-27.917-6.646-31.35S2132.687,635.549,2132.687,635.549Z",
    transform: "translate(-1985.566 -613.969)",
    fill: "#f6a268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M2125.885,619.665a2.467,2.467,0,0,1,3.295,2.815c-.547,3.136-.413,6.573,2.522,7.289,5.648,1.379,8.318,0,9.241.955s-2.669,6.046,0,7,4.108-8.167,6.47-8.167,2.876,13.153,0,16.123.411,7,4.211,7-.48,4.773,4.638,6.365,9.226,1.591,10.868-4.88,0-10.076,0-10.076,5.231-6.117,3.9-12.163c-.739-3.361-4.14-9.406-4.14-9.406a88.63,88.63,0,0,1-3.356-11.313c-.719-4.137-10.9-8.274-17.877-9.016s-3.483-4.985-9.337-4.985-6.657,7.73-6.657,7.73-8.358-5-8.746-4.76c-4.865,2.963-.822,8.168-.822,8.168s-4.005.424-4.827,5.622,2.567,8.379,7.907,6.682C2124.188,620.326,2125.089,619.993,2125.885,619.665Z",
    transform: "translate(-1976.17 -589.633)",
    fill: "#311f46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M2129.7,607.7a29.5,29.5,0,0,1,4.01.958c2.5,1.392,5.553,3.216,5.553,3.216s10.91,3.053,17.162,6.033a192.278,192.278,0,0,1,19.749,10.668c.2.556.316.883.316.883s1.25,2.223,2.4,4.722c-4.963-1.085-14.656-4.822-25.467-9.975C2141.219,618.383,2129.016,608.279,2129.7,607.7Z",
    transform: "translate(-1985.773 -596.566)",
    fill: "#0c004a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M2197.868,684.333s2.824-5.2,5.339-2.3,1.194,15.17-2.67,15.17S2196.5,687.621,2197.868,684.333Z",
    transform: "translate(-2030.333 -645.122)",
    fill: "#ff7446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M2276.7,798.752s-7.873,5.992-7.731,32.489c.075,14.125,4.222,38.059,6.776,46.716,10.6-3.351,25.559-3.569,36.388,0,1.46-11.56-1.489-36.229-3.326-44.2C2304.284,814.159,2287.949,794.268,2276.7,798.752Z",
    transform: "translate(-2077.842 -722.431)",
    fill: "#febcba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M2150.133,587.377a22.245,22.245,0,0,1,40.16,19.14c-.2.423-.419.833-.644,1.237l-40.072-19.1C2149.75,588.227,2149.932,587.8,2150.133,587.377Z",
    transform: "translate(-1998.927 -574.866)",
    fill: "#f98b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M2158.463,592.389c.172-.429.354-.856.555-1.279a22.082,22.082,0,0,1,23.952-12.145,22.631,22.631,0,0,0-3.276-1.912,22.141,22.141,0,0,0-29.561,10.323c-.2.423-.383.85-.556,1.279l40.072,19.1C2189.723,607.622,2158.463,592.389,2158.463,592.389Z",
    transform: "translate(-1998.927 -574.866)",
    fill: "#e87d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M2096.77,591.864c.426-.9,21.29,7.615,34.629,13.972s23.807,12.236,23.38,13.131-22.551-4.3-35.89-10.658S2096.343,592.759,2096.77,591.864Z",
    transform: "translate(-1964.013 -586.058)",
    fill: "#dc7572"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup734);
export default __webpack_public_path__ + "static/media/Group 734.610639d2850e7fea37ad4fdb082f83fe.svg";
export { ForwardRef as ReactComponent };